import { defineMessages } from '@jutro/locale';

export default defineMessages({
    pageHeader: {
        id: 'ml.policyChange.pup.additionalInfoToPurchase.pageHeader',
        defaultMessage: 'We\'re almost done! Just a few more questions'
    },
    additionalDetailsHeader: {
        id: 'ml.policyChange.pup.additionalInfoToPurchase.Additional Details',
        defaultMessage: 'Additional Details'
    },
    verifyingVins: {
        id: 'ml.policyChange.pup.additionalInfoToPurchase.Verifying VINs',
        defaultMessage: 'Verifying VIN\'s'
    },
    driver: {
        id: 'ml.policyChange.pup.additionalInfoToPurchase.Driver',
        defaultMessage: 'Driver'
    },
    excludedDriver: {
        id: 'ml.policyChange.pup.additionalInfoToPurchase.Excluded Driver',
        defaultMessage: 'Excluded Driver'
    },
    householdMember: {
        id: 'ml.policyChange.pup.additionalInfoToPurchase.Household Member',
        defaultMessage: 'Household Member'
    },
    vehicleX: {
        id: 'ml.policyChange.pup.additionalInfoToPurchase.vehicleX',
        defaultMessage: 'Vehicle #{vehicleNumber}'
    },
    vehicleOperatorX: {
        id: 'ml.policyChange.pup.additionalInfoToPurchase.vehicleOperatorX',
        defaultMessage: '#{vehicleOperatorNumber}'
    },
    watercraftOperatorX: {
        id: 'ml.policyChange.pup.additionalInfoToPurchase.watercraftOperatorX',
        defaultMessage: 'Watercraft Operator #{watercraftOperatorNumber}'
    },
    serialNumber: {
        id: 'ml.policyChange.pup.additionalInfoToPurchase.Serial Number',
        defaultMessage: 'Serial Number'
    },
    enterSerialNumber: {
        id: 'ml.policyChange.pup.additionalInfoToPurchase.Enter Serial Number',
        defaultMessage: 'Enter Serial Number'
    },
    driverLicense: {
        id: 'ml.policyChange.pup.additionalInfoToPurchase.Driver License',
        defaultMessage: 'Driver\'s License'
    },
    stateLicensed: {
        id: 'ml.policyChange.pup.additionalInfoToPurchase.State Licensed',
        defaultMessage: 'State Licensed'
    },
    ageFirstLicensed: {
        id: 'ml.policyChange.pup.additionalInfoToPurchase.Age First Licensed',
        defaultMessage: 'Age First Licensed'
    },
    emailAddress: {
        id: 'ml.policyChange.pup.additionalInfoToPurchase.Email Address',
        defaultMessage: 'Email Address'
    },
    enterEmailAddress: {
        id: 'ml.policyChange.pup.additionalInfoToPurchase.Enter Email Address',
        defaultMessage: 'Enter Email Address'
    },
    occupation: {
        id: 'ml.policyChange.pup.additionalInfoToPurchase.Occupation',
        defaultMessage: 'Occupation'
    },
    ocupationTooltip: {
        id: 'ml.policyChange.pup.additionalInfoToPurchase.occupationTooltip',
        defaultMessage: 'Where permissible by law, your occupation is one of the factors used in determining your rate, as well as, your eligibility for discounts.'
    },
    ocupationTooltipTitle: {
        id: 'ml.policyChange.pup.additionalInfoToPurchase.occupationTooltipTitle',
        defaultMessage: 'Why do you need my occupation?'
    },
    licenseStateTooltip: {
        id: 'ml.policyChange.pup.additionalInfoToPurchase.licenseStateTooltip',
        defaultMessage: 'Select DC, Canada, US Territories or Foreign as your state licensed.'
    },
    licenseStateTooltipTitle: {
        id: 'ml.policyChange.pup.additionalInfoToPurchase.licenseStateTooltipTitle',
        defaultMessage: 'What if I don\'t have a US license?'
    },
    yearsOperatingWatercraft: {
        id: 'ml.policyChange.pup.additionalInfoToPurchase.Years Operating Watercraft',
        defaultMessage: 'Years Operating Watercraft'
    },
    licenseNumber: {
        id: 'ml.policyChange.pup.additionalInfoToPurchase.License Number',
        defaultMessage: 'License Number'
    },
    licenseState: {
        id: 'ml.policyChange.pup.additionalInfoToPurchase.License State',
        defaultMessage: 'License State'
    },
    hasLossWithin5Years: {
        id: 'ml.policyChange.pup.additionalInfoToPurchase.Have there been any umbrella or personal liability losses in the last 5 years?',
        defaultMessage: 'Have there been any umbrella or personal liability losses in the last 5 years?'
    },
    reviewAdditionalActivity: {
        id: 'ml.policyChange.pup.additionalInfoToPurchase.review for any additional activity',
        defaultMessage: 'review for any additional activity'
    },
    mvrsMayBeRun: {
        id: 'ml.policyChange.pup.additionalInfoToPurchase.MVRs may be run',
        defaultMessage: 'MVRs may be run'
    },
    nextDesc: {
        id: 'ml.policyChange.pup.additionalInfoToPurchase.nextDesc',
        defaultMessage: 'We\'ll {reviewAdditionalActivity} next and {mvrsMayBeRun}'
    },
    errorMsg: {
        id: 'ml.policyChange.pup.additionalInfoToPurchase.errorMsg',
        defaultMessage: 'Watercraft operator license number must be unique.'
    }
});
